import { Checkbox, FormControlLabel, IconButton, Stack, useTheme } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { IKPITemplate } from '../../../../../../data-models/kpi-template.data-model';
import { ROUTES } from '../../../../../../constants/RouteNameMapping';
import { TemplatePaperContainer, GoExternalLinkIconWrapper } from './KPIAssignRequestModal';

/**@deprecated */
export const KPITemplateOption = ({ template }: { template: IKPITemplate }) => {
  const { colors } = useTheme();
  const { watch, control, setValue } = useFormContext();

  const selectedTemplatedUuid = watch('templateUuid');
  const checkedTemplate = useMemo(
    () => template.uuid === selectedTemplatedUuid,
    [selectedTemplatedUuid, template.uuid]
  );

  const onOpenTemplateLink = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      window.open(`${ROUTES.KPI_TEMPLATES_FULL_ROUTE}/${template.id}`, '_blank', 'noreferrer');
    },
    [template]
  );

  const handleCheckboxChange = useCallback(
    (templateUuid: string, checked: boolean) => {
      if (checked) {
        setValue('templateUuid', templateUuid);
      } else {
        setValue('templateUuid', '');
      }
    },
    [setValue]
  );

  return (
    <TemplatePaperContainer sx={{ width: '100%' }} elevation={1}>
      <Stack
        direction={'row'}
        p={'.25rem'}
        justifyContent={'space-between'}
        width={'100%'}
        alignItems={'center'}
      >
        <FormControlLabel
          sx={{ ml: '.25rem', color: colors.neutral['70'] }}
          label={template.name}
          control={
            <Controller
              name='templateUuid'
              control={control}
              render={() => (
                <Checkbox
                  color='secondary'
                  onChange={(e) => handleCheckboxChange(template.uuid, e.target.checked)}
                  checked={checkedTemplate}
                  sx={{ mr: '.6rem' }}
                />
              )}
            />
          }
        />
      </Stack>

      <GoExternalLinkIconWrapper>
        <IconButton
          color='secondary'
          size={'medium'}
          onClick={onOpenTemplateLink}
          sx={{ position: 'absolute' }}
        >
          <OpenInNewOutlinedIcon sx={{ color: colors.primary['60'] }} />
        </IconButton>
      </GoExternalLinkIconWrapper>
    </TemplatePaperContainer>
  );
};
